import { CLEAR_PAGE } from '../base/types';
import { FETCH_AGORA_CONSULTATION } from './consultationsActionsTypes';

const INIT_STATE = {
  isLoading: false,
  isLoaded: false,
  isRejected: false,
  isAuth: false,
};

const agoraConsultationReducer = (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case `${FETCH_AGORA_CONSULTATION}_PENDING`:
      return {
        ...state,
        isLoading: true,
      };
    case `${FETCH_AGORA_CONSULTATION}_FULFILLED`:
      return {
        ...state,
        data: payload,
        isLoaded: true,
        isLoading: false,
      };
    case `${FETCH_AGORA_CONSULTATION}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isRejected: true,
        isLoading: false,
      };

    case CLEAR_PAGE:
      return payload === 'agora' ? INIT_STATE : state;

    default:
      return state;
  }
};

export default agoraConsultationReducer;
